// extracted by mini-css-extract-plugin
export var container = "_bf-1";
export var cornerButtonContainer = "_bf-6";
export var disabled = "_bf-2";
export var dragActive = "_bf-3";
export var fileContainer = "_bf-5";
export var hiddenInput = "_bf-4";
export var widthContainer = "_bf-0";